/**
 * @kia/shared — the single source of truth for types and contracts used by BOTH the server
 * and the web app. Domain DTOs, validation schemas, roles/permissions, money, and the API
 * error contract live here so the two sides can never drift.
 */
export * from './roles.js';
export * from './money.js';
export * from './moneySchema.js';
export * from './errors.js';
export * from './dealState.js';
export * from './schemas.js';
export * from './normalize.js';
export * from './iranId.js';
export * from './motor.js';
export * from './payments.js';
export * from './faDigits.js';
export * from './jalali.js';
export * from './accounting.js';
export * from './pricing.js';
export * from './moadian.js';
export * from './setup.js';
export * from './configBounds.js';
export * from './clock.js';
/** App-wide metadata. */
export const APP = {
    name: 'برج کنترل',
    company: 'کیا الکتروموتور پارت',
    tagline: 'سامانهٔ فروش و بهای تمام‌شده',
    currency: 'IRR (ریال)',
};
//# sourceMappingURL=index.js.map